export default __webpack_public_path__ + "static/media/Ancient Spear.f7594b17.jpg";